<template>
    <div>
        <div class="pagetitle">
            <h1>Client</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">Client</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahClient" @click="user()">
                <i class="bi bi-plus fa-sm text-white-50"></i> Tambah Client
            </a>
        </div>
        <br>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Client</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" v-model="searchQuery" @change="getClient" placeholder="Search by Status ....... " class="form-control mb-3">
                            <div class="form-group mb-3">
                                <label for="pageSize" class="form-label">Items per page :</label>
                                <select id="pageSize" v-model="pageSize" @change="getClient" class="form-select">
                                    <option v-for="size in [1,5,10,15,20,100]" :key="size" :value="size">
                                        {{ size }}
                                    </option>
                                </select>
                            </div>
                            <table class="table table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">No</th>
                                        <th scope="col">Gambar</th>
                                        <th scope="col">Status</th>
                                        <th scope="col" style="text-align: center;">Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(client, index) in filteredClients" :key="client.id">
                                        <th scope="row">{{ index + 1 + (currentPage - 1) * pageSize }}</th>
                                        <td>
                                            <a :href="`${apiUrl}${client.gambar}`" target="_blank">
                                                <img :src="`${apiUrl}${client.gambar}`" alt="client image" width="100" height="100" />
                                            </a>
                                        </td>
                                        <td>
                                            <span v-if="client.status == '1'" class="badge bg-success">Active</span>
                                            <span v-else class="badge bg-danger">Inactive</span>
                                        </td>
                                        <td style="text-align: center;">
                                            <a href="#" class="btn btn-sm btn-outline-primary shadow-sm"  style="margin-right: 5px" @click="showModal('detail',client.id)">
                                                <i class="bi bi-info-circle fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-warning shadow-sm" style="margin-right: 5px" @click="showModal('edit',client.id)">
                                                <i class="bi bi-pencil-square fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-danger shadow-sm" style="margin-right: 5px" @click="deleteClient(client.id, client.gambar)">
                                                <i class="bi bi-trash fa-sm text-dark"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center" @change="getClient">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                    </li>
                                    <li v-if="showStartEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="page in displayedPages"
                                        :key="page"
                                        :class="{ active: currentPage === page }"
                                    >
                                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                    </li>
                                    <li v-if="showEndEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === pages }">
                                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Tambah -->
        <div class="modal fade" id="tambahClient" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">Client Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addClient" enctype="multipart/form-data" :headers="{ 'Content-Type': 'multipart/form-data' }">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="ID" placeholder="ID" v-model="client.created_by" readonly>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="nama" placeholder="nama" v-model="client.created_by_name" readonly>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="gambar">Gambar</label>
                                    <div class="input-group">
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" id="gambar" @change="handleFileUpload" accept=".png, .jpg, .jpeg">
                                            <label class="custom-file-label" for="gambar">{{ gambarName }}</label>
                                        </div>
                                    </div>
                                    <div v-if="gambarUrl" class="mt-3 text-center">
                                        <img :src="gambarUrl" alt="Selected Image" class="img-thumbnail" style="max-width: 200px; max-height: 200px;">
                                    </div>
                                </div>
                            </div>                            
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="status" id="status" v-model="client.status">
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                    <label for="status">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button> ||
                                <button type="reset" class="btn btn-secondary" @click="resetForm">Reset</button>
                            </div>
                        </form><!-- End floating Labels Form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail  -->
        <div ref="detailClientModal" class="modal fade" id="detailClient" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailClientModalLabel">Detail Client</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="gambar">Client</label>
                                        <div class="text-center">
                                            <a :href="`${apiUrl}${client.gambar}`" target="_blank">
                                                <img :src="`${apiUrl}${client.gambar}`" alt="client image" width="100" height="100" />
                                            </a>                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="pembuat_nama">Nama Pembuat</label>
                                        <input type="text" class="form-control" id="pembuat_nama" placeholder="Nama Pembuat" v-model="client.created_by_name" readonly>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        <select class="form-control" name="status" id="status" v-model="client.status" disabled>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-secondary" @click="closeModal"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Edit -->
        <div class="modal fade" id="editClient" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editClientModalLabel">Edit Client</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="updateClient">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="updated_by" placeholder="ID" v-model="selectedClient.updated_by" readonly/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="updated_by_name" placeholder="Nama PEmbuat" v-model="selectedClient.updated_by_name" readonly/>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="hidden" class="form-control" id="floatingName" placeholder="ID" v-model="client.id" readonly/>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="gambar">Gambar</label>
                                    <div class="text-center">
                                        <a :href="`${apiUrl}${client.gambar}`" target="_blank">
                                            <img :src="`${apiUrl}${client.gambar}`" alt="client image" width="100" height="100" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                <select class="form-select" name="status" id="status" v-model="client.status">
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                                <label for="is_active">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>    
    </div>
</template>

<script>
import clientjs from './jsClient/client';
export default clientjs;
</script>